import { formatChatMessageTime, useTranslation } from "hhn-commons";
import { MessageStatusProps } from "../RecipientMessageStatus";
import {
  MessageDeliveryStatusBox,
  MessageReadDeliveredIcon,
} from "./MessageStatus.style";

const MessageReadStatus = ({
  timestamp,
  showText = true,
}: MessageStatusProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  return (
    <MessageDeliveryStatusBox
      isMessageRead={true}
      data-testid="message-read-status"
    >
      <MessageReadDeliveredIcon />
      {showText && `${tNs("messageInfo.messageReadStatus")}, `}
      {timestamp && formatChatMessageTime(timestamp)}
    </MessageDeliveryStatusBox>
  );
};
export default MessageReadStatus;
